import React, { useMemo } from 'react';
import ReactYoutube, { Options as YoutubeOptions } from 'react-youtube';
import { populatePlayerOptionsWithLanguage } from './player-utils';
import style from './YoutubePlayer.module.pcss';

export interface Props extends YoutubeOptions {
  videoId: string;
  playerLanguage?: string;
}

const YoutubePlayer: React.FC<Props> = ({
  videoId,
  playerLanguage,
  ...youtubeOpts
}) => {
  const playerOptionsWithLang = useMemo<YoutubeOptions>(
    () => populatePlayerOptionsWithLanguage(playerLanguage, youtubeOpts),
    [playerLanguage, youtubeOpts]
  );

  return (
    <div className={style.YoutubePlayer}>
      <ReactYoutube videoId={videoId} opts={playerOptionsWithLang} />
    </div>
  );
};

export default YoutubePlayer;
